/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CashflowDto } from '../../models/cashflow-dto';

export interface GetEffectiveClashflow$Params {
  projectId: string;
  budgetIds?: Array<string>;
}

export function getEffectiveClashflow(http: HttpClient, rootUrl: string, params: GetEffectiveClashflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CashflowDto>> {
  const rb = new RequestBuilder(rootUrl, getEffectiveClashflow.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('budgetIds', params.budgetIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CashflowDto>;
    })
  );
}

getEffectiveClashflow.PATH = '/v0/Cashflow/effective';
